export const responseIsJson = (contentType: unknown): boolean => {
  const value = String(contentType || '').toLowerCase();
  return value.includes('application/json') || value.includes('+json');
};

export interface PdfDownloadResponse {
  downloadUrl: string;
  filename?: string;
  expiresAt?: string;
  [key: string]: unknown;
}

export type PdfServerResponse = ArrayBuffer | PdfDownloadResponse;

export const decodeJsonArrayBuffer = (data: unknown): unknown => {
  if (!(data instanceof ArrayBuffer)) return data;

  const decoded = new TextDecoder('utf-8').decode(new Uint8Array(data));
  return decoded ? JSON.parse(decoded) : null;
};

export const decodePdfServerResponse = (data: unknown, contentType: unknown): unknown => (
  responseIsJson(contentType) ? decodeJsonArrayBuffer(data) : data
);
